export default __webpack_public_path__ + "static/media/scan.cd019565.svg";